import { render } from "./News_page_en_m.vue?vue&type=template&id=61bad8a0&scoped=true"
import script from "./News_page_en_m.vue?vue&type=script&lang=js"
export * from "./News_page_en_m.vue?vue&type=script&lang=js"

import "./News_page_en_m.vue?vue&type=style&index=0&id=61bad8a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61bad8a0"

export default script